// https://alligator.io/vuejs/global-event-bus/
// helping components communicate across the router
import Vue from 'vue';
export const EventBus = new Vue();
